module.exports = __webpack_public_path__ + "Project.dbb02d9bc84ec40bb15ba8b500218519.hashedasset.svg";